const _ = [
  "#a46130",
  "#e99d44",
  "#f4e07c",
  "#b79ec2",
  "#40185b"
], E = [
  _[0],
  _[1],
  _[2],
  _[3],
  "#7b589d",
  _[4]
], c = [
  _[0],
  "#c7762c",
  _[1],
  _[2],
  _[3],
  "#7b589d",
  _[4]
], A = [
  _[0],
  "#c7762c",
  _[1],
  _[2],
  "#d9cba2",
  _[3],
  "#7b589d",
  _[4]
], L = [
  _[0],
  "#c7762c",
  _[1],
  "#fcbe71",
  _[2],
  "#d9cba2",
  _[3],
  "#7b589d",
  _[4]
], P = [
  _[0],
  "#c7762c",
  _[1],
  "#fcbe71",
  "#fbd170",
  _[2],
  "#d9cba2",
  _[3],
  "#7b589d",
  _[4]
];
export {
  P as HEAT_MAP_ORANGE_YELLOW_PURPLE_10,
  _ as HEAT_MAP_ORANGE_YELLOW_PURPLE_5,
  E as HEAT_MAP_ORANGE_YELLOW_PURPLE_6,
  c as HEAT_MAP_ORANGE_YELLOW_PURPLE_7,
  A as HEAT_MAP_ORANGE_YELLOW_PURPLE_8,
  L as HEAT_MAP_ORANGE_YELLOW_PURPLE_9
};
//# sourceMappingURL=index.es5673.js.map
